import { AssistResourceTypeInfoBM } from '../resources';
import { AssistFilterBM } from './assist-filter-bm.model';
import { AssistTimelineDefaultsBM } from './assist-timeline-defaults-bm.model';
import { AssistFloorplanDefaultsBM } from './assist-floorplan-defaults-bm';
import { AssistReservationDefaultsBM } from './assist-reservation-defaults-bm';
import { AssistInfoSettingsBM } from './assist-info-settings-bm';
import { AssistAreasBM } from './assist-areas-bm';
import { AssistServiceTypeBM } from './assist-service-type-bm';
import { AssistServiceBM } from './assist-service-bm';
import { QRCategoryItemModel } from './qr-category-item-model.model';
import { LocalizedString } from './localized-string';
import { AssistThemeBm } from './assist-theme-bm';
import { DesignBm } from './design-bm';
import { MapEngine } from './map-engine.model';

export type ServerType = 'o365' | 'ews' | 'gspace' | 'touchone-calendar';

export interface ExternalLoginCA {
  id: number;
  tenantId: string;
  clientId: string;
  prompt: string;
  serverTypeId: number;
  externalLoginText?: string;
}

export interface LanguageInfoBM {
  code: string;
  default: boolean;
  activeInAssist: boolean;
  activeInNavigation: boolean;
  activeInMapApp: boolean;
  activeInMonitorControlApp: boolean;
  activeInReservationPanelApp: boolean;
}

export enum PoiPurposesEnum {
  NoPurposes = 1,
  Resource = 2,
  News = 3,
  Kiosk = 4,
  Unit = 5,
  MonitorControlObject = 6,
}

export enum QrCodeShowOnFloorplanEnum {
  No = 1,
  AccordingPoiSettings = null,
  OnlyName = 6,
  OnlyCode = 12,
  CategoryIconName = 3,
  CategoryIconCode = 13,
  CodeName = 14,
}

export interface DeploymentSettings {
  enabled: boolean;
  id: string;
  poiPurposes: PoiPurposesEnum[];
  qrCodeShowOnFloorplanId: QrCodeShowOnFloorplanEnum;
  showMonitorControlInMap: boolean;
  showNotNavigationPoiInMap: boolean;
  showResourceInMap: boolean;
}

export interface AssistConfigurationBM {
  reservationRemindTime: number | null;
  searchInUsers: boolean;
  languages: LanguageInfoBM[];
  googleAnalyticsEnabled: boolean;
  googleAnalyticsKey?: string;
  assistNavigationInfo: string;
  navigationInfo: string;
  emailLinkLoginEnabled: boolean;
  passwordLoginEnabled: boolean;
  resourceVisibilityRestriction: number;
  showNavigationDashboardLink: boolean;
  forceResourceToNavigation: boolean;
  enableGroupFinding: boolean;

  autoMeetingSettings_Teams: boolean;
  autoMeetingSettings_Meet: boolean;
  autoMeetingSettings_Webex: boolean;
  autoMeetingSettings_Zoom: boolean;
  webexEnabled: boolean;
  zoomEnabled: boolean;
  cachingEnabled: boolean;
  resourceTypeInfos: AssistResourceTypeInfoBM[];
  connectionAgentId?: number;
  tenantId: string;
  clientId: string;
  serverType: ServerType;
  assistUrl: string;
  favIconUrl?: string;
  theme: AssistThemeBm;
  design: DesignBm;
  filters: AssistFilterBM[];
  timelineDefaults: AssistTimelineDefaultsBM;
  floorplanDefaults: AssistFloorplanDefaultsBM;
  reservationDefaults: AssistReservationDefaultsBM;
  infoSettings: AssistInfoSettingsBM;
  id: string;
  enableFindTheCollegue: boolean;
  areas: AssistAreasBM[];
  navigationEnabled: boolean;
  newsTitle: LocalizedString;
  allowGuests: boolean;
  enableReservations: boolean;
  enableOrders: boolean;
  newsAvailable: boolean;
  serviceTypes: AssistServiceTypeBM[];
  services: AssistServiceBM[];
  prompt?: string;
  navigationAppEnabled: boolean;
  navigationAppUrl?: string;
  qrCategories: QRCategoryItemModel[];
  companyLogoUrl?: string;
  companyLogoDarkUrl?: string;
  loginPageBackgroundUrl?: string;
  externalLoginCAs: ExternalLoginCA[];
  backendFindPathEnabled?: boolean;
  url?: string;
  enableStepNavigation: boolean;
  gpsInfo: boolean;
  recurringOverLimitActionId?: number;
  assistCreatingReccuringEventsEnabled: boolean;
  calendarSyncTimeline: boolean;
  mapEngine: MapEngine;
  showSatisfactionRatingsAnalytics: boolean;
}
